import React from 'react';
import { AnnouncementBar } from '../components/sections/AnnouncementBar';
import { HeroSection } from '../components/sections/HeroSection';
import { PainPoints } from '../components/sections/PainPoints';
import { Benefits } from '../components/sections/Benefits';
import { ThisIsForYou } from '../components/sections/ThisIsForYou';
import { MeetSara } from '../components/sections/MeetSara';
import { Transformation } from '../components/sections/Transformation';
import { ProductPresentation } from '../components/sections/ProductPresentation';
import { Bonuses } from '../components/sections/Bonuses';
import { Testimonials } from '../components/sections/Testimonials';
import { PlatformTrustBar } from '../components/sections/PlatformTrustBar';
import { FAQ } from '../components/sections/FAQ';
import { FinalCTA } from '../components/sections/FinalCTA';
import { Footer } from '../components/sections/Footer';
import { StickyMobileCTA } from '../components/sections/StickyMobileCTA';
import { SectionDivider } from '../components/ui/SectionDivider';
export function LandingPage() {
  return <div className="min-h-screen bg-dark text-cream font-lato overflow-x-hidden relative" data-id="element-426">
      <AnnouncementBar data-id="element-427" />

      <main data-id="element-428">
        <HeroSection data-id="element-429" />
        <SectionDivider data-id="element-430" />

        <PainPoints data-id="element-431" />
        <SectionDivider data-id="element-432" />

        <Benefits data-id="element-433" />
        <div className="py-6 md:py-10" data-id="element-434" />

        <ThisIsForYou data-id="element-435" />
        <div className="py-6 md:py-10" data-id="element-436" />

        <MeetSara data-id="element-437" />
        <SectionDivider data-id="element-438" />

        <Transformation data-id="element-439" />
        <SectionDivider data-id="element-440" />

        <ProductPresentation data-id="element-441" />
        <SectionDivider data-id="element-442" />

        <Testimonials data-id="element-443" />
        <div className="py-6 md:py-10" data-id="element-444" />

        <Bonuses data-id="element-445" />
        <div className="py-6 md:py-10" data-id="element-446" />

        <PlatformTrustBar data-id="element-447" />
        <SectionDivider data-id="element-448" />

        <FAQ data-id="element-449" />
        <SectionDivider data-id="element-450" />

        <FinalCTA data-id="element-451" />
      </main>

      <Footer data-id="element-452" />

      <StickyMobileCTA data-id="element-453" />
    </div>;
}